module.exports = __webpack_public_path__ + "static/iQube-Logo-2034037b10bcbd93578588aa10a07589.png";